import { type FC } from 'react';

import Clear from '@mui/icons-material/Clear';

import { mergeSx } from '../../util/mui/sx';
import { IconButton, type IconButtonProps } from '../buttons/IconButton';
import { Centered } from '../structural/Centered';

interface TextInputClearButtonProps extends IconButtonProps {
  readonly isVisible: boolean;
}

export const TextInputClearButton: FC<TextInputClearButtonProps> = ({ isVisible, ...props }) => (
  <Centered aspectRatio={1}>
    {isVisible && (
      <IconButton
        icon={Clear}
        {...props}
        sx={mergeSx({ maxHeight: '100%', padding: '0.1rem', width: 'auto' }, props.sx)}
      />
    )}
  </Centered>
);
